import { __rest } from 'tslib';
import React from 'react';
import { useControllableState, useCallbackRef } from '@10d/tend-ui-hooks';
import { Input } from '../Input/Input.js';

const UNSTABLE_InputNumber = (_a) => {
    var { disabled, placeholder, value, defaultValue, onChange, allowClear, before, after } = _a, props = __rest(_a, ["disabled", "placeholder", "value", "defaultValue", "onChange", "allowClear", "before", "after"]);
    const [__input = null, __setNumber] = useControllableState({
        defaultValue: defaultValue,
        value: value,
        onChange: onChange,
    });
    const handleChange = useCallbackRef((e) => {
        const payload = e.target.value;
        if (payload === '') {
            __setNumber(null);
            return;
        }
        const isNumber = /^-?\d*$/.test(payload);
        if (!isNumber)
            return;
        __setNumber(parseInt(payload, 10));
    });
    return (React.createElement(Input, Object.assign({ "data-testid": 'tend-ui-input-number' }, props, { value: __input ? String(__input) : '', placeholder: placeholder, disabled: disabled, onChange: handleChange, allowClear: allowClear, prefix: before, suffix: after })));
};
UNSTABLE_InputNumber.displayName = 'UNSTABLE_InputNumber';

export { UNSTABLE_InputNumber };
